import React from "react";
import {
  BADRI_NATH,
  img_url1,
  img_url10,
  img_url2,
  img_url3,
  img_url4,
  img_url5,
  img_url6,
  img_url7,
  img_url8,
  img_url9,
} from "../Constant/Constants";
import Bslideshow from "./Bslideshow";
import "../Landingpage/Landing.css";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

export default function Badrinath() {
  //   var myIndex = 0;
  //   carousel();

  //   function carousel() {
  //     var i;
  //     var x = document.getElementsByClassName("mySlides");
  //     for (i = 0; i < x.length; i++) {
  //       x[i].style.display = "none";
  //     }
  //     myIndex++;
  //     if (myIndex > x.length) {
  //       myIndex = 1;
  //     }
  //     x[myIndex - 1].style.display = "block";
  //     setTimeout(carousel, 2000); // Change image every 2 seconds
  //   }
  return (
    <>
      <div className="b_main_div">
        {/* <div className="b_img_div" style={{ maxWidth: "500px" }}>
          <img
            className="mySlides"
            src={img_url1}
            style={{ maxWidth: "100%" }}
          />
          <img
            className="mySlides"
            src={img_url2}
            style={{ maxWidth: "100%" }}
          />
          <img
            className="mySlides"
            src={img_url3}
            style={{ maxWidth: "100%" }}
          />
        </div> */}
        {/* <h1>hello</h1> */}
        <Bslideshow />
        <h1 className="slide_text">Badrinath temple</h1>
      </div>
      <div class="dropdown">
        <h2>Special Features</h2>
        <div class="dropdown-content">
          <h3>Foundation year</h3>
          <p> 1750–500 BC</p>
          <h4>Architechture</h4>
          <p>
            The temple is located in Garhwal hill tracts along the banks of the
            Alaknanda River[2] in Chamoli district in Uttarakhand. The hill
            tracts are located 3,133 m (10,279 ft) above the mean sea
            level.[3][4] The Nar Parbat mountain is located opposite to the
            temple, while the Narayana Parbat is located behind the Neelkanth
            peak.[5] The temple has three structures: the Garbhagriha (sanctum),
            the Darshan Mandap (worship hall), and Sabha Mandap (convention
            hall).[3][5][6] The conical-shaped roof of the sanctum, the
            garbhagriha, is approximately 15 m (49 ft) tall with a small cupola
            on top, covered with a gold gilt roof.[5][7] The facade is built of
            stone and has arched windows. A broad stairway leads up to the main
            entrance, a tall, arched gateway. Just inside is a mandap, a large,
            pillared hall that leads to the sanctum, or main shrine area. The
            walls and pillars of the hall are covered with intricate
            carvings.[1] The main shrine houses the 1 ft (0.30 m) Shaligram
            (black stone) deity of Badrinarayana, which is housed in a gold
            canopy under a Badri Tree. The deity of Badrinarayana shows Him
            holding a Shankha (conch) and a Chakra (wheel) in two of His arms in
            a lifted posture and the other two arms resting on His lap in a
            Yogamudra (Padmasana) posture.[3][6] The sanctum also houses images
            of the god of wealth—Kubera, sage Narada, Uddhava, Nar and Narayan.
            There are fifteen more images that are also worshipped around the
            temple. These include that of Lakshmi (the consort of Vishnu),
            Garuda (the vahana of Narayan), and Navadurga, the manifestation of
            Durga in nine different forms. The temple also has shrines of
            Lakshmi Narasimhar and for saints Adi Shankara (AD 788-820), Nar and
            Narayan, Ghantakarna, Vedanta Desika and Ramanujacharya. All the
            deities of the temple are made of black stone.[1][3][5] The Tapt
            Kund, a group of hot sulphur springs just below the temple, are
            considered to be medicinal; many pilgrims consider it a requirement
            to bathe in the springs before visiting the temple. The springs have
            a year-round temperature of 55 °C (131 °F), while outside
            temperature is typically below 17 °C (63 °F) all year round.[3] The
            two water ponds in the temple are called Narad Kund and Surya
            Kund.[8]
          </p>
        </div>
      </div>
      <div className="iframe_div">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2683.418972942707!2d79.48888921433874!3d30.744782842104502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a78c1fc736a8e5%3A0xb19c97240a0e94ef!2sShree%20Badrinath%20Temple!5e1!3m2!1sen!2sin!4v1657869285912!5m2!1sen!2sin"
          //   width="600"
          //   height="450"
          //   style="border:0;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="related_temples">
        <h1 className="related_text">Realated temples</h1>
        <div
          className="grid_images"
          style={{
            // border: "1px solid red",
            height: "50px",
            width: "100%",
            marginTop: "50px",
            marginBottom:"350px"
          }}
        >
          <div className="image_box">
            <div className="img_div">
              <img className="imgbox" src={img_url4}></img>
              <h5 className="grid_temple_name">Kashi Vishwanath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Varanasi, Uttar Pradesh</p>
            </div>
            <div className="img_div">
              <img className="imgbox" src={img_url5}></img>
              <h5 className="grid_temple_name">Golden Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Amritsar, Punjab</p>
            </div>
            <div className="img_div">
              <img className="imgbox" src={img_url6}></img>
              <h5 className="grid_temple_name">Vaishno Devi Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">
                Vaishno Devi, Jammu & Kashmir
              </p>
            </div>
            <div className="img_div">
              <img className="imgbox" src={img_url7}></img>
              <h5 className="grid_temple_name">Akshardham Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">New Delhi, Delhi</p>
            </div>
            {/* <div className="img_div">
              <img className="imgbox" src={img_url8}></img>
              <h5 className="grid_temple_name">lotus Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">New Delhi, Delhi</p>
            </div> */}
            {/* <div className="img_div">
              <img className="imgbox" src={img_url9}></img>
              <h5 className="grid_temple_name">Dakshineswar Kali Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Kolkata, West Bengal</p>
            </div> */}
            {/* <div className="img_div">
              <img className="imgbox" src={img_url10}></img>
              <h5 className="grid_temple_name">Jagannath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Puri, Orissa</p>
            </div> */}
            {/* <div className="img_div">
              <Link to={BADRI_NATH}>
                <img className="imgbox" src={img_url2}></img>
                <h5 className="grid_temple_name">Badrinath Temple</h5>
                <Icon
                  className="grid_temple_icon"
                  icon="akar-icons:location"
                  width="20"
                />
                <p className="grid_temple_location">Badrinath, Uttarakhand</p>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
